module.exports = __webpack_public_path__ + "img/21a7903.png";